let logger;

export const setLogger = (config) => {
  ({ logger } = config);
};

export const logTrace = (scenarioName, content) => {
  if (logger && logger.trace) {
    logger.trace(scenarioName, content || 'No content to log.');
  }
};
